import { render, staticRenderFns } from "./news-detail.vue?vue&type=template&id=d9523cd6&scoped=true"
import script from "./news-detail.vue?vue&type=script&lang=js"
export * from "./news-detail.vue?vue&type=script&lang=js"
import style0 from "./news-detail.vue?vue&type=style&index=0&id=d9523cd6&prod&scoped=true&lang=css"
import style1 from "./news-detail.vue?vue&type=style&index=1&id=d9523cd6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9523cd6",
  null
  
)

export default component.exports